export default "__VITE_ASSET__CtKzrihw__"